import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  PmpAlertItem,
  PmpAlertStatus,
  toPmpAlertUpdatePayload,
  updatePmpAlert,
} from '../../api/pmp-alert';

const STATUS_OPTIONS: { value: PmpAlertStatus; label: string }[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'complete', label: 'Complete' },
];

type Props = {
  alert: PmpAlertItem;
  disabled?: boolean;
  onStatusSaved: (next: PmpAlertStatus) => void;
};

const PmpAlertInlineStatusSelect: React.FC<Props> = ({
  alert,
  disabled = false,
  onStatusSaved,
}) => {
  const current: PmpAlertStatus = alert.pmp_status === 'complete' ? 'complete' : 'pending';
  const [localStatus, setLocalStatus] = useState<PmpAlertStatus>(current);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    setLocalStatus(alert.pmp_status === 'complete' ? 'complete' : 'pending');
  }, [alert.id, alert.pmp_status]);

  const handleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const next = e.target.value as PmpAlertStatus;
    if (next === localStatus) return;
    const previous = localStatus;
    setLocalStatus(next);
    setPending(true);
    try {
      await updatePmpAlert(toPmpAlertUpdatePayload(alert, next));
      onStatusSaved(next);
      toast.success('Status updated successfully');
    } catch {
      setLocalStatus(previous);
      toast.error('Could not update PMP alert status');
    } finally {
      setPending(false);
    }
  };

  return (
    <select
      className='pmp-alert-inline-status-select'
      value={localStatus}
      onChange={handleChange}
      disabled={disabled || pending}
      aria-label='PMP alert status'
    >
      {STATUS_OPTIONS.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default PmpAlertInlineStatusSelect;
